// extracted by mini-css-extract-plugin
export default {"featureIcon":"FeatureIcon_featureIcon__ad7n4"};